<template>
  <v-snackbar
    v-model="showToast"
    :color="toastData.type === 'error' ? 'error' : 'info'"
    :timeout="toastData.timeout || 3000"
    top
    right
  >
    {{ toastData.message }}
    
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="showToast = false"
      >
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "ToastRedirecionamento",
  
  data() {
    return {
      showToast: false,
      toastData: {
        type: 'info',
        message: '',
        timeout: 3000
      }
    };
  },

  methods: {
    showToastMessage(data) {
      this.toastData = { ...data };
      this.showToast = true;
    }
  }
};
</script> 